import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItemText,
  Typography
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";

const ValidationMessageModal = (props) => {
  const { open, validation, } = props;
  const [fieldList, setFieldList] = useState({ inputField: false, allocationField: false });
  const [messageList, setMessageList] = useState([])

  const getMessages = (object) => {
    const keys = Object.keys(object);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (k !== "contributions") {
        if (!object[k].valid) {
          console.log(object[k])
          if (object[k].show) {
            setMessageList(v => {
              return [...v, object[k].message]
            });
          }

          if (k === "detailsAccountMust_100") {
            setFieldList(v => ({ ...v, allocationField: true }));
            // setMessages(messages => ([...messages, object[k].message]))
          } else {
            setFieldList(v => ({ ...v, inputField: true }));
            // setMessages(messages => ([...messages, object[k].message]))
          }
        };
      } else if (!getMessages(object[k])) {
        return false;
      }
    }
    return true;
  };

  const processMessages = (validation) => {
    if (validation.hasOwnProperty("accounts")) {  //means current validation
      validation.accounts.forEach(element => {
        getMessages(element);
      });

      validation.incomes.forEach(element => {
        getMessages(element);
      });

      validation.goals.forEach(element => {
        getMessages(element)
      });
      getMessages(validation.client);
      getMessages(validation.spouse);
    }

    if (validation.hasOwnProperty("fiaTransfers")) {  //means future validation
      validation.fiaTransfers.forEach(element => {
        getMessages(element);
      });
      validation.rothTransfers.forEach(element => {
        getMessages(element);
      });
      validation.insuranceTransfers.forEach(element => {
        getMessages(element);
      });
      validation.spendingGoals.forEach(element => {
        getMessages(element);
      });
    }

  }

  useEffect(() => {
    setFieldList([]);
    setMessageList([])
    processMessages(validation);
  }, [validation]);

  const closeModal = () => {
    props.setOpenModal((v) => ({ ...v, [props.modal]: false }))
    setFieldList([]);
    setMessageList([]);
  }
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={() => {
        closeModal()
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >

      <DialogTitle style={{ backgroundColor: '#007BEF', color: 'white' }} >{"Error"}</DialogTitle>

      <DialogContent style={{ margin: "auto" }}>
        <Box mt={3}>
          {messageList.length > 0 ?

            <ul>{
              messageList.map((e, idx) => {
                return (
                  <li key={idx}>
                    <Typography
                      className={'default-font'}
                      textAlign={'left'}
                      variant={'span'}> {e}
                    </Typography>
                  </li>
                );
              })}
            </ul>
            :
            <>
              <Typography
                className={'default-font'}
                textAlign={'left'}
                variant={'span'}>
                {"Please ensure the following are corrected:"}
              </Typography>
              <ul>
                {fieldList.inputField && <li>
                  <Typography
                    className={'default-font'}
                    textAlign={'left'}
                    variant={'span'}>
                    {"All the inputs highlighted in red to ensure they are valid."}
                  </Typography>
                </li>}
                {fieldList.allocationField && <li>
                  <Typography
                    className={'default-font'}
                    textAlign={'left'}
                    variant={'span'}>
                    {"Account allocation adds up to 100%"}
                  </Typography>
                </li>}
              </ul>
            </>
          }

        </Box>


      </DialogContent>
      <DialogActions>

        <Button onClick={closeModal} >Accept</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationMessageModal;
